import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { VolunteerProspect } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';


export function getColumns(util: UtilityService, domainData: DomainDataService, app: AppService) {
	console.log(domainData.data().accApplicationStatusesMap)
	const columns: GridColumn<VolunteerProspect, unknown>[] = [
		buildColumn(util, 'Id', row => row.assignedToStaffId, { header: 'assignedToStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.assignedToStaffId), { header: 'Assigned Staff', width: 50 }),
		buildColumn(util, 'Id', row => row.lastContactStaffId, { header: 'lastContactStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.lastContactStaffId), { header: 'Last Contacted By', width: 50 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.lastContactUTC), { header: 'Last Contact Date', width: 50 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.lastAutoEmailDeliveredUTC), { header: 'Last Auto Email Date', width: 50, hidden: true }),
		buildColumn(util, 'Id', row => row.volunteerId),
		buildColumn(util, 'FullName', row => row.person.fullName, { width: 40 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.createdUTC), { header: 'Lead Created Date', width: 30 }),
		buildColumn(util, 'YesNo', row => row.mentorInterest, { header: 'Mentor Interest', width: 30 }),
		buildColumn(util, 'YesNo', row => row.inClassInterest, { header: 'In-Class Interest', width: 30 }),
		buildColumn(util, 'YesNo', row => row.officeHoursInterest, { header: 'Office Hours Interest', width: 30 }),
		buildColumn(util, 'YesNo', row => row.willVolunteerInEnglish, { header: 'English', width: 20 }),
		buildColumn(util, 'YesNo', row => row.willVolunteerInSpanish, { header: 'Spanish', width: 20 }),
		buildColumn(util, 'Text', row => row.availableStart, { header: 'Start Date', width: 30 }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.interviewDateUTC), { header: 'Interview Date', width: 30 }),
		buildColumn(util, 'Percent', row => row.interviewScore, { header: 'Interview Score', width: 30, hidden: true }),
		buildColumn(util, 'Text',
			row => row.questionnaireLearnId ? domainData.data().questionnaireLearnMap[row.questionnaireLearnId]?.name : undefined,
			{ header: 'Channel', headerTooltip: 'Questionnaire result: How did you learn about EforAll?', width: 80, hidden: false }
		),
	];

	return columns;

}
